export default __webpack_public_path__ + "static/media/电解质水.ca55932c.jpg";